import React from 'react';
import { Field } from 'formik';
import PropTypes from 'prop-types';
import { Price } from 'components';
import { RiCheckboxBlankLine, RiCheckboxFill } from 'react-icons/ri';

function Marker({ markerOptions }) {
  if (markerOptions && markerOptions.isVisible)
    return (
      <div>
        <div className="mb-2 flex items-center justify-between">
          <span className="text-xs font-bold uppercase">
            {markerOptions.title}
          </span>
          {markerOptions.price && (
            <Price
              unitPrice={markerOptions.price}
              priceSize="xs"
              priceFontWeight="semibold"
            />
          )}
        </div>
        <div className="flex" role="group">
          <label htmlFor={markerOptions.name} className="w-full">
            <Field name={markerOptions.name}>
              {({ field }) => (
                <div className="flex min-h-[48px] w-full items-center justify-between border border-solid border-gray px-4 hover:cursor-pointer">
                  <div className="flex items-center space-x-2">
                    {markerOptions.image && markerOptions.image !== '' && (
                      <img
                        className="h-6 w-6"
                        src={markerOptions.image}
                        alt={markerOptions.addon_name}
                      />
                    )}
                    <span className="text-sm group-checked:text-xl">
                      {markerOptions.addon_name}
                    </span>
                  </div>
                  <input
                    {...field}
                    id={markerOptions.name}
                    className="peer hidden"
                    aria-label={markerOptions.title}
                    type="checkbox"
                  />
                  <RiCheckboxBlankLine className="block h-6 w-6 text-gray peer-checked:hidden" />
                  <RiCheckboxFill className="hidden h-6 w-6 text-green peer-checked:block" />
                </div>
              )}
            </Field>
          </label>
        </div>
      </div>
    );
  return null;
}

Marker.propTypes = {
  markerOptions: PropTypes.shape({
    price: PropTypes.string,
    name: PropTypes.string,
    value: PropTypes.bool,
    addon_info_text: PropTypes.string,
    title: PropTypes.string,
    type: PropTypes.string,
    id: PropTypes.number,
    image: PropTypes.string,
    addon_name: PropTypes.string,
  }),
};

Marker.defaultProps = {
  markerOptions: undefined,
};

export default Marker;
